<template>
  <v-content class="login">
    <!-- logo -->
    <v-row align-content="center" justify="center" no-gutters class="logo">
      <img :src="logo" height="50px" style="width:auto; max-width:100%;" />
    </v-row>

    <div class="px-3 mt-10">
      <p class="body-2 mb-10">仮登録メールに記載された<br>6桁の認証コードを入力してください。</p>

      <ValidationObserver ref="observer" v-slot="{ invalid }">
      <v-row class="">
        <v-col cols="12" sm="6" class="pb-0">
          <p class="subtitle-2 font-weight-black ma-0 text-center">認証コード</p>
          <ValidationProvider ref="provider" v-slot="{ errors }" name="認証コード" rules="required|numeric|max:6|min:6">
          <v-text-field v-model="code" maxlength="6" label single-line outlined dense :error-messages="errors" required></v-text-field>
          </ValidationProvider>
        </v-col>
      </v-row>

      <div class="text-center">
        <v-btn rounded :disabled="invalid || btnDisabledFlg" class="maincolor-bg default_button mb-5" @click.stop="auth()">認証</v-btn>
        <v-btn rounded class="caption font-weight-black mb-10" style="background-color:#EFEFEF;" to="regist">新規登録画面に戻る</v-btn>

        <p class="text-left caption">※メールが届かなかった場合は、以下をお確かめの上、<br>解決しない場合は新規登録画面から再度メールを設定ください<br><br>
          【仮登録メールが届かない場合】<br><br>
          ＜メールアドレス入力前の注意点＞<br>
          ・配信ドメイン『@usen.com 』を受信できるよう設定してください。<br>
          ・迷惑メール防止機能は、一時的に解除、もしくは強度を下げてください。<br>
          ・自分に空メールを送信し、そのメールが受信できるか確認してください。<br><br>
          ＜メールアドレス入力時の注意点＞<br>
          スペルミス、打ち間違い、記号の入力ミス(ドット「．」ハイフン「－」などの入力数間違いなど)にご注意ください。
        </p>
      </div>
      </ValidationObserver>

      <div class="text-center caption pt-10">
        <p class="caption" v-if="mailto">
          <v-icon>far fa-envelope</v-icon> <a :href="'mailto:'+mailto">お問い合わせ</a>
        </p>
      </div>

      <p class="text-center" v-if="copyright" style="font-size: 12px; margin-top:60px;">© {{copyright}} All right reserved.</p>
    </div>

    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
    </v-overlay>

  </v-content>
</template>

<script>
import { required, numeric, max, min } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
setInteractionMode('eager')
extend('required', {
  ...required,
  message: '{_field_} は必須項目です。',
})

extend('numeric', {
  ...numeric,
  message: '数字のみが利用できます',
})

extend('max', {
  ...max,
  message: '6文字で入力してください。',
})

extend('min', {
  ...min,
  message: '6文字で入力してください。',
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      code: null,
      logo: this.storageGet('top_logo_image'),
      mailto: this.storageGet('inquiry_mail'),
      shop_name: this.storageGet('shop_name'),
      copyright: this.storageGet('copyright'),
      routing: [],
      result: [],
      validatecheck: null,
      userregist: [],
      loading: false,
      btnDisabledFlg: false
    };
  },
  async created () {

  },
  methods: {
    auth: function(){
      // 多重処理防止
      if (this.btnDisabledFlg) return

      this.$refs.observer.validate().then(async validatecheck => {
        if (validatecheck) {
          try {
            //スピナー表示, ボタンdisabled
            this.loading = true
            this.btnDisabledFlg = true

            // 事業者情報取得API実行
            var business_service_req = {
              params: {
                'sid': this.storageGet('sid')
              }
            }
            var business_service_res = await this.apiCall('/business-service/get-info', business_service_req)

            //ユーザー本登録API
            var auth_req = {
              'sid': this.storageGet('sid'),
              'service_cd': this.storageGet('service_cd'),
              'login_id': this.storageGet('auth_login_id'),
              'password': this.storageGet('auth_password'),
              'shop_name': this.storageGet('shop_name'),
              'auth_code': this.code,
              'email': business_service_res.data.email,
              'email_name': business_service_res.data.email_name
            }
            var res = await this.apiCall('/regist-user', auth_req, 'post', 2);
            this.$set(this, 'result', res);
            if (!res) { return false } // resが返らない時のエラーは共通エラー処理でやるので、処理中断だけで良い。
             

            if (!res.auth_id) throw "auth error" // 認証チェック

            //ユーザー本登録APIから取得したtokenをlocalstrageに保存
            this.storageSave(JSON.stringify({
              'auth_id': res.auth_id,
              'access_token': res.access_token,
              'refresh_token': res.refresh_token,
              'settlement_token': res.settlement_token,
            }))

            /* user regist API実行 */
            var initregist_req = {
              'registration_id': this.storageGet('registration_id'),
              'auth_id': res.auth_id,
              'device_uid': this.storageGet('device_uid'),
              'sid': this.storageGet('sid'),
              'key': this.storageGet('key'),
              'device_id': this.storageGet('device_id'),
              'os': this.storageGet('os'),
              'login_keep_flg': 1
            };
            var initregist_res = await this.apiCall('/user/registinit', initregist_req, 'post');
            if (!initregist_res) { return false }

            this.storageSave(JSON.stringify({
              'device_uid': initregist_res.device_uid,
              'device_id': initregist_res.device_uid
            }))

            /* user regist API実行 */
            var userregist_req = {
              'registration_id': this.storageGet('registration_id'),
              'auth_id': res.auth_id,
              'device_uid': this.storageGet('device_uid'),
              'sid': this.storageGet('sid'),
              'key': this.storageGet('key'),
              'device_id': this.storageGet('device_id'),
              'os': this.storageGet('os'),
              'login_keep_flg': 0,
              'email': this.storageGet('auth_login_id'),
            };
            var userregist_res = await this.apiCall('/user/regist', userregist_req, 'post');
            if (!userregist_res) { return false }

            this.$set(this, 'userregist', userregist_res)
            this.storageSave(JSON.stringify({
              'user_id': userregist_res.user_id,
              'user_name': userregist_res.user_name,
            }))

            /* ルーティングAPIを叩く */
            var routing_req = { params: {
              'sid': this.storageGet('sid'),
              'device_uid': this.storageGet('device_uid'),
              'key': this.storageGet('key'),
              'device_id': this.storageGet('device_id'),
              'os': this.storageGet('os'),
              'feature_id': 'registration_code',
              'service_cd': this.storageGet('service_cd')
            }};
            var routing_res = await this.apiCall('/user/routing', routing_req, 'get');
            if (!routing_res) { return false }
            this.$set(this, 'routing', routing_res);

            //ネイティブに送るデータを生成
            var tonative_req = {
              'Access-Token': this.result.access_token,
              'Refresh-Token': this.result.refresh_token,
              'Settlement-Token': this.result.settlement_token,
              'destination': this.routing.destination,
              'feature_id': this.routing.feature_id,
              'screen_id': this.routing.screen_id,
              'transition_type': this.routing.transition_type,
              'user_id': this.userregist.user_id,
              'user_name': this.userregist.user_name,
              'device_uid': this.userregist.device_uid,
            };
            //console.log(tonative_req)

            //ログイン情報保持フラグありの場合、ログインIDとパスワードをlocalstorageに保存
            const encryptedText = this.CryptoJS.AES.encrypt(this.storageGet('auth_password'), this.storageGet('auth_login_id')).toString()
            this.storageSave(JSON.stringify({
              'login_id': this.storageGet('auth_login_id'),
              'password': encryptedText,
            }))

            //不要なlocalstorageを削除
            this.storageDelete('auth_login_id')
            this.storageDelete('auth_password')

            if (!(this.screenTransition(tonative_req))) {
              this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
            }
          } catch(e) {
            this.callDialog('認証コードエラー', '認証コードを確認してください。', 3);
          } finally {
            // 正常, 異常に関わらず処理完了時はスピナー, ボタンdisabled解除
            this.loading = false
            this.btnDisabledFlg = false
          }
        }
      });
    },
  }
};
</script>

<style scoped>

.fontsize12>>>label {
  font-size: 12px;
}

a {
  color: #333333;
}
</style>
